import type { BusinessCatalogItem } from '~/api/graphql/generated/types'
import { getOneUomPluralized } from '~/components/dashboard/admin/catalog/inventory/inventoryUtils'
import i18n from '~/locales/i18n'

export const getInventoryItemDisplayName = (
  inventoryItem:
    | Pick<BusinessCatalogItem, 'name' | 'variation'>
    | null
    | undefined,
): string => {
  if (!inventoryItem) {
    return ''
  }

  return [
    inventoryItem.name?.trim(),
    inventoryItem.variation?.composedName?.trim(),
  ]
    .filter(Boolean)
    .join(' | ')
}

export const getInventoryItemDisplayQuantity = ({
  orderedQuantity,
  perPackageAmount,
  productSizeUnit,
  packageType,
}: {
  orderedQuantity: number
  packageType: string
  perPackageAmount: number
  productSizeUnit: string
}): { breakdown: string; total: string } => {
  const totalAmount = orderedQuantity * perPackageAmount
  const pluralizedProductUnit = getOneUomPluralized(
    productSizeUnit,
    totalAmount,
  )
  const pluralizedPackageType = getOneUomPluralized(
    packageType,
    orderedQuantity,
  )
  const pluralizedProductUnitForPerPackage = getOneUomPluralized(
    productSizeUnit,
    perPackageAmount,
  )
  const singularPackageType = getOneUomPluralized(packageType, 1)

  const total = `${totalAmount} ${pluralizedProductUnit}`
  const breakdown = i18n.t(
    'Admin:CATALOG.ORDERS.ORDER_ITEM_QUANTITY_BREAKDOWN',
    {
      quantity: orderedQuantity,
      packageType: pluralizedPackageType,
      amount: perPackageAmount,
      unit: pluralizedProductUnitForPerPackage,
      singularPackageType,
    },
  )

  return { total, breakdown }
}
